import { render, staticRenderFns } from "./articleListStyle.vue?vue&type=template&id=656585c9&scoped=true"
import script from "./articleListStyle.vue?vue&type=script&lang=js"
export * from "./articleListStyle.vue?vue&type=script&lang=js"
import style0 from "./articleListStyle.vue?vue&type=style&index=0&id=656585c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656585c9",
  null
  
)

export default component.exports